const inputPFList = [
  'inputTrim',
  'inputWaste',
  'inputReady',
  'inputUndercut',
  'inputAllWaste'
];

const productionStoringNames = {
  dataGridInputTrim: 'dataGridInputTrimUpd',
  dataGridInputWaste: 'dataGridInputWasteUpd',
  dataGridInputReady: 'dataGridInputReadyUpd',
  dataGridInputUndercut: 'dataGridInputUndercutUpd',
  dataGridInputAllWaste: 'dataGridInputAllWasteUpd'
};
// ['inputTrim', 'inputWaste', 'inputReady', 'inputUndercut'];
export { inputPFList, productionStoringNames };

export const imageFileTypes = ['.jpg', '.jpeg', '.png'];
export const documentFileTypes = ['.msg', '.pdf', '.docx', '.xls', '.xlsx'];
